module.exports = __webpack_public_path__ + "img/Germantown_Grille@1x.abe7a636.png";